import { catalogItem } from 'store/auth';
import { useSelector } from 'react-redux';

export const useCatalogIdByAlias = (catalogAlias: string) => {
    const catalogItems: catalogItem[] = useSelector((state: any) => state.auth?.userInfo?.catalogItems) ?? [];
    const currentCatalog = catalogItems.find((catalogItem) => catalogItem.url_name === catalogAlias);
    return currentCatalog ? currentCatalog.catalog_id : 0;
};

export const useDefaultCatalogId = () => {
    const catalogItems: catalogItem[] = useSelector((state: any) => state.auth?.userInfo?.catalogItems) ?? [];
    const defaultCatalog = catalogItems.find((catalogItem) => catalogItem.is_system_ind == 'Y');
    return defaultCatalog ? defaultCatalog.catalog_id : 0;
};

export const useCatalogDataById = (catalogId: number) => {
    const catalogItems: catalogItem[] = useSelector((state: any) => state.auth?.userInfo?.catalogItems) ?? [];
    return catalogItems.find((catalogItem) => catalogItem.catalog_id === catalogId);
};

export const useCatalogDataByAlias = (catalogAlias: string) => {
    const catalogItems: catalogItem[] = useSelector((state: any) => state.auth?.userInfo?.catalogItems) ?? [];
    return catalogItems.find((catalogItem) => catalogItem.url_name === catalogAlias);
};
